import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Image,
  Link,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import Understanding from "../img/understanding.png";
import React from "react";
import { RightIcon } from "../components/Icons";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

const Article = () => {
  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Understanding the Leasing Process</title>
          <link rel="canonical" href={ absoluteUrl( "/understanding-the-leasing-process")} />
        </Helmet>
    <Box mt={"91px"}>
      <Container maxW={{ md: "85%", base: "100%" }} pt={8}>
        <Image
          src={Understanding}
          borderRadius={{ md: "30px", base: "12px" }}
        />
        <Grid
          mt={{ md: 20, base: 10 }}
          gap={{ md: 16, base: 4 }}
          gridTemplateColumns={"repeat(8,1fr)"}
        >
          <GridItem
            colSpan={{ md: 5, base: 8 }}
            px={{ md: 8, base: 2 }}
            pos={"relative"}
            _after={{
              content: { md: '""', base: "unset" },
              pos: "absolute",
              w: "1px",
              h: "100%",
              bgColor: "DarkTeal",
              right: "-5%",
              top: 0,
            }}
          >
            <Heading mb={10} color={"DarkBlue"}>
              Understanding the Leasing Process: What to expect when leasing a
              medical office space for your practice
            </Heading>
            <Text>
              Leasing medical office space is a pivotal step for healthcare
              professionals looking to establish or expand their practices.
              However, it's a process that demands careful consideration and
              guidance to ensure success. In this article, we'll walk you
              through the crucial steps and key considerations when leasing
              medical office space, with insights into how Welltower Inc. can be
              your trusted partner throughout this journey.
            </Text>
            <List ms={{ md: 10, base: 6 }}>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 1: Determine Your Needs
                </Text>
                <Text>
                  Before embarking on the leasing process, the first essential
                  step is to determine your specific requirements. Assess
                  factors such as location, size, and layout to find an office
                  space that aligns with your practice's needs. Welltower's
                  knowledgeable team can assist you in identifying and designing
                  a space that caters to both you and your patients.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 2: Research and Explore Options
                </Text>
                <Text>
                  Comprehensive research is vital to locate available medical
                  office spaces in your desired location. Welltower's experts
                  can help you explore suitable options and provide valuable
                  insights to guide you through the leasing process.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 3: Touring Potential Spaces
                </Text>
                <Text>
                  Once you've identified potential spaces, it's time to schedule
                  visits and evaluate each one. During these tours, assess
                  various aspects, including the layout, amenities, parking
                  availability, and overall suitability for your practice. Make
                  note of any modifications or buildouts that may be necessary.
                  Welltower even offers virtual tours to facilitate this
                  process, making it more convenient for you.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 4: Negotiate Lease Terms
                </Text>
                <Text>
                  Negotiating the lease agreement is a critical phase. Key
                  factors to consider include the lease duration, rent, tenant
                  improvement allowance, and any special requirements specific
                  to your practice. Welltower's expertise can help you navigate
                  this negotiation phase successfully.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 5: Review the Lease Agreement
                </Text>
                <Text>
                  Before signing any documents, carefully review the lease
                  agreement. Ensure that all agreed-upon terms are accurately
                  reflected in the contract. If necessary, seek legal advice to
                  fully comprehend the terms and obligations outlined in the
                  agreement.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 6: Set Up the Office
                </Text>
                <Text>
                  With the lease signed, you can begin the process of setting up
                  your medical office. Coordinate with contractors and vendors
                  to complete any necessary buildouts, install equipment, and
                  furnish the space to meet your practice's needs.
                </Text>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Step 7: Begin Operations
                </Text>
                <Text>
                  Once your office is fully set up, you can start seeing
                  patients and operating your practice. Be sure to monitor the
                  lease terms closely and fulfill your obligations as outlined
                  in the agreement.
                </Text>
              </ListItem>
            </List>
            <Text mt={6}>
              By following these steps and considering the key factors, you can
              navigate the leasing process for medical office space
              successfully. Remember to seek professional advice when needed and
              ensure that the chosen space meets all your practice's
              requirements.
            </Text>
            <Text mt={6}>
              Welltower is your trusted partner in the journey of leasing
              medical office space. Our team of experts is dedicated to helping
              you find the perfect space that aligns with your practice's unique
              needs. With Welltower by your side, you can confidently establish
              or expand your healthcare practice in a space designed for
              success.
            </Text>
            <Text fontStyle={"italic"} mt={6}>
              The information on this website is for informational purposes only
              and not for the purpose of providing legal advice.
            </Text>
          </GridItem>
          <GridItem colSpan={{ md: 3, base: 8 }} px={{ md: 8, base: 2 }}>
            <Box pos={"sticky"} top={20}>
              <Text color={"DarkTeal"} fontSize={"2xl"}>
                Other Articles
              </Text>
              <List color={"DarkBlue"}>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/what-is-mob">
                    <Text>
                      What is an MOB (Medical Office Building) and Why It
                      Matters in Healthcare?
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/healthcare-real-estate-terms-simplified">
                    <Text>Healthcare Real Estate Leasing Terms Simplified</Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/benefits-of-leasing">
                    <Text>
                      Benefits of Leasing vs. Owning Medical Office Buildings
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
              </List>
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </Box>
        </>
  );
};

export default Article;
